<template>
  <header class="mainHeader" style="-webkit-text-size-adjust: none;">
    <div class="flex items-center justify-between px-2 header-nav w1200">
      <div class="clearfix searchNav">
        <a class="fl headLogo" href="/">
          <img src="../../assets/images/common/logoOuter.png" style="width:110%"/>
        </a>
        <span class="nowShow blueBg borderRadius ml20 mr10 nowStuSection"></span>
        <div class="searchBox" v-if="false">
          <input placeholder="请输入关键字" />
          <button class="noBorderBtn"></button>
        </div>
      </div>
     <div class="flex justify-center items-center" style="-webkit-text-size-adjust: none;">
        <!-- <router-link to="/download" class="mr-4 font-bold flex justify-center items-center">
          <el-link type="primary" class="font-bold text-base">资源下载</el-link>
        </router-link> -->
        <router-link to="/ucenter/index" v-if="isLogin">
            <span class="inline-block px-4 py-1 my-5 text-white bg-green-400 rounded-lg ml-4">个人中心</span>
          </router-link>
        <div v-if="isLogin">
          <span @click="doLogout" class="inline-block px-4 py-1 my-5 text-white bg-gray-400 rounded-lg ml-4">退出登录</span>
        </div>

        <!-- <div v-if="!isLogin" class="flex">
          <router-link to="/login">
            <button class="mx-2 noBorderBtn loginIn">登录</button>
          </router-link>
          |
          <router-link  :to="`/register?v=${Math.random() * 100000000000000000 }`">
            <button class="mx-2 noBorderBtn register">免费注册</button>
          </router-link>
        </div> -->
        
        <div v-if="!isLogin" class="flex">
          <button class="mx-2 noBorderBtn loginIn font-bold" @click="showLoginModal=true">登录</button>
          |
          <button class="mx-2 noBorderBtn register font-bold" @click="showRegisterModal=true">免费注册</button>
        </div>
     </div>
     
    </div>
    <LoginModal :show="showLoginModal" @update:show="val => showLoginModal = val" @login:success="loginSuccessHandle" />
    <RegisterModal :show="showRegisterModal" @update:show="val => showRegisterModal = val" @register:success="registerSuccessHandle" />
  </header>
</template>
<script lang="ts" setup>
import { onMounted, ref } from "vue";
import useJump from "../../hooks/useJump";
import CommonUtils from "../../utils/CommonUtils";
import UserService from "../../apis/UserService";
import MittUtil from "../../utils/MittUtil";
const showLoginModal = ref(false);
const showRegisterModal = ref(false);
const isLogin = ref(false);

//@ts-ignore
MittUtil.on("isLogin", (e:boolean) => {
  console.log("MittUtil", e);

  isLogin.value = e;
});
const jump = useJump();
// const isLogin = ref(false);
onMounted(() => {
  if (CommonUtils.isLogin()) {
    isLogin.value = true;
  } else {
    isLogin.value = false;
  }
});
const doLogout = () => {
  UserService.logout();
  setTimeout(()=>{
    CommonUtils.clearLocalStore();
    jump("/");
    MittUtil.emit("isLogin", false);
  },60)
};
const loginSuccessHandle = ()=>{
  MittUtil.emit("isLogin", true);
}
const registerSuccessHandle = ()=>{
  //TODO 注册成功
  showRegisterModal.value = false;
}
</script>
<style lang="scss"></style>
